import { render, staticRenderFns } from "./ChatDetails.vue?vue&type=template&id=04106f70&scoped=true&"
import script from "./ChatDetails.vue?vue&type=script&lang=js&"
export * from "./ChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChatDetails.vue?vue&type=style&index=0&id=04106f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04106f70",
  null
  
)

export default component.exports